import { Plugin } from '@nuxt/types';
import { initializeAxios } from '@/utils/api';

const api: Plugin = (context, _inject) => {
	initializeAxios(context.$axios); // to initialize and then be accessible in store modules using : import { $axios } from '@/utils/api'
	// inject('api', context.$axios); // inject into the app. Use in components with this.$api
};

export default api;
